import {Directive, Input, NgModule, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import { CngPermissionsService } from '@signature-it/ngx-generic/services';

@Directive({
    selector: '[cngPermissionAction]',
    standalone: false
})
export class PermissionActionDirective implements OnInit {

    @Input('cngPermissionAction') data;

    constructor(
        private cngPermissionsService: CngPermissionsService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    ngOnInit(): void {
        this.checkPermissions();
    }

    private checkPermissions(): void {
        if (this.data.avoidApplyCondition) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }
        this.cngPermissionsService.hasPermission(this.data.cngId, this.data.permission)
            .subscribe(
                hasPermission => {
                    if (hasPermission) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                    }
                }
            )

    }
}
@NgModule({
    declarations: [PermissionActionDirective],
    exports: [PermissionActionDirective]
})
export class PermissionActionDirectiveModule {}
